var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEu({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2196_112906)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H64V64H0V0Z",
    fill: "#003399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9999 29.1396L31.0518 32.3001L32.632 32.6162L31.9999 29.1396Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0001 29.1396L32.9482 32.3001L31.368 32.6162L32.0001 29.1396Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0065 31.3236L31.7077 31.3985L31.8954 32.9991L35.0065 31.3236Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0064 31.3238L32.2936 33.2022L31.5047 31.797L35.0064 31.3238Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8585 34.8574L32.7679 31.7432L31.3037 32.4163L33.8585 34.8574Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8585 34.8572L31.2337 32.8577L32.3264 31.6731L33.8585 34.8572Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9937 31.3236L32.2926 31.3985L32.1048 32.9991L28.9937 31.3236Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9938 31.3238L31.7066 33.2022L32.4955 31.797L28.9938 31.3238Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1417 34.8574L31.2323 31.7432L32.6965 32.4163L30.1417 34.8574Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1417 34.8572L32.7665 32.8577L31.6738 31.6731L30.1417 34.8572Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9999 29.1396L31.0518 32.3001L32.632 32.6162L31.9999 29.1396Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0001 29.1396L32.9482 32.3001L31.368 32.6162L32.0001 29.1396Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0065 31.3236L31.7077 31.3985L31.8954 32.9991L35.0065 31.3236Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0064 31.3238L32.2936 33.2022L31.5047 31.797L35.0064 31.3238Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8585 34.8574L32.7679 31.7432L31.3037 32.4163L33.8585 34.8574Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8585 34.8572L31.2337 32.8577L32.3264 31.6731L33.8585 34.8572Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9937 31.3236L32.2926 31.3985L32.1048 32.9991L28.9937 31.3236Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9938 31.3238L31.7066 33.2022L32.4955 31.797L28.9938 31.3238Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1417 34.8574L31.2323 31.7432L32.6965 32.4163L30.1417 34.8574Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1417 34.8572L32.7665 32.8577L31.6738 31.6731L30.1417 34.8572Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9999 29.1396L31.0518 32.3001L32.632 32.6162L31.9999 29.1396Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0001 29.1396L32.9482 32.3001L31.368 32.6162L32.0001 29.1396Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0065 31.3236L31.7077 31.3985L31.8954 32.9991L35.0065 31.3236Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0064 31.3238L32.2936 33.2022L31.5047 31.797L35.0064 31.3238Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8585 34.8574L32.7679 31.7432L31.3037 32.4163L33.8585 34.8574Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8585 34.8572L31.2337 32.8577L32.3264 31.6731L33.8585 34.8572Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9937 31.3236L32.2926 31.3985L32.1048 32.9991L28.9937 31.3236Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9938 31.3238L31.7066 33.2022L32.4955 31.797L28.9938 31.3238Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1417 34.8574L31.2323 31.7432L32.6965 32.4163L30.1417 34.8574Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1417 34.8572L32.7665 32.8577L31.6738 31.6731L30.1417 34.8572Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8936 18.5775L23.5183 16.5779L22.4257 15.3933L20.8936 18.5775Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.893 18.5773L21.9837 15.4631L23.4479 16.1363L20.893 18.5773Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7458 15.0443L22.4586 16.9227L23.2475 15.5175L19.7458 15.0443Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7461 15.0446L23.0449 15.1195L22.8571 16.72L19.7461 15.0446Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7514 12.8606L21.8032 16.0211L23.3835 16.3371L22.7514 12.8606Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7516 12.8606L23.6997 16.0211L22.1195 16.3371L22.7516 12.8606Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6094 18.5779L21.9846 16.5784L23.0773 15.3938L24.6094 18.5779Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6094 18.5773L23.5188 15.4631L22.0546 16.1363L24.6094 18.5773Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7574 15.0445L23.0446 16.9229L22.2557 15.5177L25.7574 15.0445Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7573 15.0443L22.4585 15.1192L22.6463 16.7198L25.7573 15.0443Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5781 25.6081L16.4875 22.4939L15.0233 23.167L17.5781 25.6081Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5781 25.6077L14.9533 23.6081L16.046 22.4236L17.5781 25.6077Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8637 25.6075L16.4884 23.6079L15.3958 22.4234L13.8637 25.6075Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8636 25.6074L14.9542 22.4932L16.4185 23.1663L13.8636 25.6074Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7152 22.0736L15.428 23.952L16.217 22.5467L12.7152 22.0736Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7153 22.0734L16.0141 22.1483L15.8264 23.7488L12.7153 22.0734Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7258 22.0738L16.013 23.9522L15.2241 22.547L18.7258 22.0738Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7259 22.0736L15.4271 22.1485L15.6148 23.7491L18.7259 22.0736Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7201 19.8901L16.6682 23.0506L15.088 23.3667L15.7201 19.8901Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7199 19.8901L14.7717 23.0506L16.352 23.3667L15.7199 19.8901Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7305 41.0839L15.4317 41.1588L15.6194 42.7593L18.7305 41.0839Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7304 41.0841L16.0176 42.9625L15.2287 41.5572L18.7304 41.0841Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5816 44.6171L16.4909 41.5029L15.0267 42.1761L17.5816 44.6171Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.581 44.6173L14.9563 42.6177L16.049 41.4331L17.581 44.6173Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8662 44.6173L16.491 42.6177L15.3983 41.4331L13.8662 44.6173Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8662 44.6166L14.9568 41.5024L16.421 42.1756L13.8662 44.6166Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7237 38.8999L16.6719 42.0604L15.0916 42.3764L15.7237 38.8999Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7235 38.8999L14.7754 42.0604L16.3556 42.3764L15.7235 38.8999Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7177 41.0839L16.0166 41.1588L15.8288 42.7593L12.7177 41.0839Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7173 41.0841L15.4301 42.9625L16.219 41.5572L12.7173 41.0841Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5899 47.4452L22.2911 47.5201L22.4788 49.1207L25.5899 47.4452Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5898 47.4454L22.877 49.3238L22.0881 47.9186L25.5898 47.4454Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4409 50.9785L23.3503 47.8642L21.8861 48.5374L24.4409 50.9785Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4404 50.9786L21.8156 48.979L22.9083 47.7945L24.4404 50.9786Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7256 50.9786L23.3504 48.979L22.2577 47.7945L20.7256 50.9786Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7256 50.978L21.8162 47.8638L23.2804 48.5369L20.7256 50.978Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5831 45.2612L23.5312 48.4217L21.951 48.7378L22.5831 45.2612Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5829 45.2612L21.6348 48.4217L23.215 48.7378L22.5829 45.2612Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5771 47.4452L22.8759 47.5201L22.6882 49.1207L19.5771 47.4452Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5767 47.4454L22.2895 49.3238L23.0784 47.9186L19.5767 47.4454Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0002 29.1396L32.9484 32.3001L31.3681 32.6162L32.0002 29.1396Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 29.1396L31.0519 32.3001L32.6321 32.6162L32 29.1396Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9946 31.3236L32.2934 31.3985L32.1057 32.9991L28.9946 31.3236Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9951 31.3238L31.708 33.2022L32.4969 31.797L28.9951 31.3238Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1426 34.8571L31.2332 31.7429L32.6974 32.4161L30.1426 34.8571Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1431 34.8572L32.7678 32.8577L31.6752 31.6731L30.1431 34.8572Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0065 31.3236L31.7077 31.3985L31.8954 32.9991L35.0065 31.3236Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0069 31.3238L32.2941 33.2022L31.5052 31.797L35.0069 31.3238Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8585 34.8571L32.7679 31.7429L31.3037 32.4161L33.8585 34.8571Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.859 34.8572L31.2342 32.8577L32.3269 31.6731L33.859 34.8572Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1069 18.5775L40.4822 16.5779L41.5748 15.3933L43.1069 18.5775Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.107 18.5773L42.0163 15.4631L40.5521 16.1363L43.107 18.5773Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2542 15.0441L41.5414 16.9224L40.7525 15.5172L44.2542 15.0441Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2544 15.0443L40.9556 15.1192L41.1434 16.7198L44.2544 15.0443Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2486 12.8604L42.1968 16.0208L40.6165 16.3369L41.2486 12.8604Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2484 12.8604L40.3003 16.0208L41.8805 16.3369L41.2484 12.8604Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3911 18.5779L42.0159 16.5784L40.9232 15.3938L39.3911 18.5779Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3911 18.5773L40.4817 15.4631L41.9459 16.1363L39.3911 18.5773Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2433 15.0441L40.9561 16.9224L41.745 15.5172L38.2433 15.0441Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2431 15.0443L41.5419 15.1192L41.3542 16.7198L38.2431 15.0443Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4203 25.6054L47.5109 22.4912L48.9751 23.1644L46.4203 25.6054Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4203 25.6055L49.0451 23.6059L47.9524 22.4214L46.4203 25.6055Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1361 25.6053L47.5113 23.6057L48.604 22.4212L50.1361 25.6053Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1361 25.6052L49.0455 22.491L47.5813 23.1641L50.1361 25.6052Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.284 22.0714L48.5712 23.9498L47.7823 22.5446L51.284 22.0714Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2841 22.0712L47.9853 22.1461L48.173 23.7466L51.2841 22.0712Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2724 22.0726L47.9852 23.951L48.7741 22.5458L45.2724 22.0726Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2723 22.0724L48.5711 22.1473L48.3834 23.7479L45.2723 22.0724Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2781 19.8894L47.33 23.0499L48.9102 23.3659L48.2781 19.8894Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2783 19.8894L49.2264 23.0499L47.6462 23.3659L48.2783 19.8894Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.27 41.0839L48.5688 41.1588L48.3811 42.7593L45.27 41.0839Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2705 41.0841L47.9833 42.9625L48.7723 41.5572L45.2705 41.0841Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4184 44.6174L47.5091 41.5032L48.9733 42.1763L46.4184 44.6174Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4185 44.6175L49.0432 42.6179L47.9506 41.4334L46.4185 44.6175Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1333 44.617L47.5085 42.6174L48.6012 41.4329L50.1333 44.617Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1333 44.6169L49.0427 41.5027L47.5785 42.1758L50.1333 44.6169Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2763 38.8999L47.3281 42.0604L48.9084 42.3764L48.2763 38.8999Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2765 38.8999L49.2246 42.0604L47.6444 42.3764L48.2765 38.8999Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2823 41.0839L47.9834 41.1588L48.1712 42.7593L51.2823 41.0839Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2822 41.0841L48.5694 42.9625L47.7805 41.5572L51.2822 41.0841Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4106 47.4452L41.7094 47.5201L41.5217 49.1207L38.4106 47.4452Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4112 47.4454L41.124 49.3238L41.9129 47.9186L38.4112 47.4454Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5591 50.9787L40.6497 47.8645L42.1139 48.5376L39.5591 50.9787Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5591 50.9788L42.1839 48.9792L41.0912 47.7947L39.5591 50.9788Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2739 50.9783L40.6491 48.9788L41.7418 47.7942L43.2739 50.9783Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2739 50.9782L42.1833 47.864L40.7191 48.5372L43.2739 50.9782Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4169 45.2612L40.4688 48.4217L42.049 48.7378L41.4169 45.2612Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4171 45.2612L42.3652 48.4217L40.785 48.7378L41.4171 45.2612Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4229 47.4452L41.1241 47.5201L41.3118 49.1207L44.4229 47.4452Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4228 47.4454L41.71 49.3238L40.9211 47.9186L44.4228 47.4454Z",
    fill: "#FFCC00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2196_112906"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEu);
export default __webpack_public_path__ + "static/media/EU.8b510c50b2aac647af79a4dee51396b7.svg";
export { ForwardRef as ReactComponent };